/**
 * @packageDocumentation
 * @module StockChartModule
 */
import { Component, OnInit, Input } from '@angular/core';
import { FilterConfig } from '../stock-chart/stock-chart-model';
import { FormGroup, FormControl } from '@angular/forms';
import { StockChartService } from '../stock-chart.service';
import { startWith, pairwise, skip } from 'rxjs/operators';
import { StockChartDataService } from '../stock-chart-shared/stock-chart-shared-services/stock-chart-data.service';
import { isEmptyObject } from '../stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';

@Component({
  selector: 'app-stock-chart-filter',
  templateUrl: './stock-chart-filter.component.html',
  styleUrls: ['./stock-chart-filter.component.scss']
})
export class StockChartFilterComponent implements OnInit {
  /**
   * filter Config Input from stock chart config
   */
  @Input() filterConfig: FilterConfig[];
  /**
   * byDefaultCount of the filter
   */
  @Input() byDefaultCount: number;
  /**
   * Stock chart Id
   */
  @Input() stockChartId: string;
  filterFormGroup =  new FormGroup({});
  compareFormGroup = new FormGroup({});
  compareGroupObject: any = {};
  filterGroupObject: any = {};
  showFormGroup = false;

  constructor(
    private stockChartService: StockChartService,
    private dataService: StockChartDataService
  ) { }

  /**
   * Angular On Init function
   * update the filter subject after all the by default values got set
   */
  ngOnInit() {
    this.filterConfig.forEach( filter => {
      if (filter.type === 'dropdown') {
        this.filterFormGroup.addControl(filter.config.key, new FormControl(''));
        this.filterGroupObject[filter.config.key] = filter;
      } else {
        filter.compareConfig.forEach( compareFilter => {
          this.compareFormGroup.addControl(compareFilter.key, new FormControl(''));
        });
      }
    });
    this.showFormGroup = true;
    if (this.stockChartService.initSubjects[this.stockChartId] && this.stockChartService.initSubjects[this.stockChartId].filter) {
      this.stockChartService.initSubjects[this.stockChartId].filter.next(true);
    }
    this.filterFormGroup.valueChanges
    .pipe(startWith({}), pairwise(), skip(this.byDefaultCount - 1))
    .subscribe( ([previousValue, nextValue]: [any, any])  => {
      const fieldsChanged = this.detectChangedFields(previousValue, nextValue);
      const configForChangedFields = this.getConfigForChangedFields(fieldsChanged);
      this.stockChartService.updateFilterForm(this.stockChartId, nextValue, 'filter', fieldsChanged, configForChangedFields);
    });
  }
  /**
   * generate changedField object
   * @param changedFields fields changed from the filter
   */
  getConfigForChangedFields(changedFields) {
    const configObject: any = {};
    changedFields.forEach( (field) => {
      if (isEmptyObject(configObject[field])) {
        configObject[field] = {};
      }
      configObject[field].changeFireEventType = this.filterGroupObject[field].changeFireEventType;
      configObject[field].functionsFireOnChange = this.filterGroupObject[field].functionsFireOnChange;
    });
    return configObject;
  }
  /**
   * return whether the field is changed or not
   * @param prev prev value of the field
   * @param next current value of the field
   */
  detectChangedFields(prev, next) {
    let changedFields = [];
    for (let value of Object.keys(next)) {
      if (prev[value] !== next[value]) {
        changedFields.push(value);
      }
    }
    return changedFields;
  }
  /**
   * update the filter form in the stock chart service based on Id
   */
  submit() {
    const clearedData = this.dataService.clearEmptyFields(this.compareFormGroup.value);
    if (isEmptyObject(clearedData)) {
      this.stockChartService.updateFilterForm(this.stockChartId, null, 'compare');
    } else {
      this.stockChartService.updateFilterForm(this.stockChartId, clearedData, 'compare');
    }
  }
  /**
   * reset the filter data
   * not present in the UI
   */
  reset() {
    for (let control of Object.keys(this.compareFormGroup.controls)) {
      this.compareFormGroup.get(control).setValue('');
    }
    this.stockChartService.updateFilterForm(this.stockChartId, null, 'compare');
  }

}
